/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_Bottom_Left_LabelInputs */



/**
* | output |
* | --- |
* | "Bottom Left" |
*
* @param {Style_Guide_Manager_Position_Bottom_Left_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_bottom_left_label = /** @type {((inputs?: Style_Guide_Manager_Position_Bottom_Left_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_Bottom_Left_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bas gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unten links")
	if (locale === "it") return /** @type {LocalizedString} */ ("In basso a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нижний левый угол")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abajo a la izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("左下角")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左下")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तली छोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Canto inferior esquerdo")
	return /** @type {LocalizedString} */ ("Bottom Left")
});